import { render, staticRenderFns } from "./SettingsPipelineOnboarding.vue?vue&type=template&id=648b4098"
import script from "./SettingsPipelineOnboarding.vue?vue&type=script&lang=js"
export * from "./SettingsPipelineOnboarding.vue?vue&type=script&lang=js"
import style0 from "./SettingsPipelineOnboarding.vue?vue&type=style&index=0&id=648b4098&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports